/* eslint-disable max-len */
export const chartProps = {
  chartType: {
    type: String,
    default: 'bar',
  },
  backgroundColor: {
    type: Array,
    default: ['#9182DE'],
  },
  borderColor: {
    type: Array,
    default: ['#9182DE'],
  },
  datalabel: {
    type: String,
    default: 'Demo Chart',
  },
  pointBgColor: {
    type: String,
    default: '#fff',
  },
  pointHoverBgColor: {
    type: String,
    default: '#fff',
  },
  pointHoverBorderColor: {
    type: String,
    default: '#fff',
  },
  pointBorderColor: {
    type: String,
    default: ['#fff'],
  },
  type: {
    type: String,
    default: 'line',
  },
  dataSets: {
    type: Array,
    default: null,
  },
  dataArray: {
    type: Array,
    default: null,
  },
  options: {
    type: Object,
    default() {
      return {
        responsive: true,
        curvature: 10,
        maintainAspectRatio: false,
        lineTension: 0,
        elements: {
          point: {
            radius: 1,
          },
          line: {
            tension: 0,
          },
        },
        datasets: { bar: { categoryPercentage: 0.5, barPercentage: 0.9 } },
        scales: {
          xAxes: [{
            barThickness: 40,
            display: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              autoSkip: false,
              fontSize: 14,
            },
          }],
          yAxes: [{
            display: true,
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
              borderDash: [8, 4],
              color: '#E8E8E8',
              drawBorder: false,
            },
          }],
        },
        tooltips: {
          mode: 'index',
          position: 'nearest',
          cornerRadius: 9,
          xPadding: 0,
          yPadding: 16,
          caretSize: 0,
          backgroundColor: '#ffffff',
          enabled: false,
          custom(tooltip) {
            if (!tooltip) return;
            // eslint-disable-next-line no-param-reassign
            tooltip.displayColors = false;

            let tooltipEl = document.getElementById('chartjs-tooltip');

            // Create element on first render
            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = 'chartjs-tooltip';
              tooltipEl.innerHTML = '<table></table>';
              document.body.appendChild(tooltipEl);
            }

            // Hide if no tooltip
            if (tooltip.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform');
            if (tooltip.yAlign) {
              tooltipEl.classList.add(tooltip.yAlign);
            } else {
              tooltipEl.classList.add('no-transform');
            }

            function getBody(bodyItem) {
              return bodyItem.lines;
            }

            // Set Text
            if (tooltip.body) {
              const bodyLines = tooltip.body.map(getBody);

              let innerHtml = '<thead>';

              innerHtml += '</thead><tbody>';

              bodyLines.forEach((body, i) => {
                const colors = tooltip.labelColors[i];
                let style = `background: ${colors.backgroundColor}`;
                style += `; border-color: ${colors.borderColor}`;
                style += '; border-width: 1px';
                const span = `<span style="" ${style}'"></span>`;
                innerHtml += `<tr><td>
                <svg style="display: inline-block; margin-right: 10px" width="11" height="9" viewBox="0 0 37 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.6667 18.8H26.7167V18.75V3.75V3.7H26.6667H3.33333H3.28333V3.75V18.75V18.8H3.33333H26.6667ZM33.3833 26.25V5.675H33.3865H33.397H33.4074H33.4178H33.4282H33.4385H33.4488H33.459H33.4692H33.4793H33.4894H33.4995H33.5095H33.5194H33.5294H33.5393H33.5491H33.5589H33.5686H33.5784H33.588H33.5977H33.6073H33.6168H33.6263H33.6358H33.6452H33.6546H33.6639H33.6732H33.6825H33.6917H33.7009H33.7101H33.7192H33.7282H33.7373H33.7463H33.7552H33.7641H33.773H33.7818H33.7906H33.7994H33.8081H33.8168H33.8254H33.8341H33.8426H33.8512H33.8597H33.8681H33.8766H33.885H33.8933H33.9016H33.9099H33.9182H33.9264H33.9346H33.9427H33.9508H33.9589H33.9669H33.975H33.9829H33.9909H33.9988H34.0067H34.0145H34.0223H34.0301H34.0378H34.0455H34.0532H34.0608H34.0685H34.076H34.0836H34.0911H34.0986H34.106H34.1135H34.1209H34.1282H34.1356H34.1429H34.1501H34.1574H34.1646H34.1718H34.1789H34.186H34.1931H34.2002H34.2072H34.2142H34.2212H34.2282H34.2351H34.242H34.2489H34.2557H34.2625H34.2693H34.276H34.2828H34.2895H34.2962H34.3028H34.3094H34.316H34.3226H34.3291H34.3357H34.3422H34.3486H34.3551H34.3615H34.3679H34.3743H34.3806H34.3869H34.3932H34.3995H34.4058H34.412H34.4182H34.4244H34.4305H34.4367H34.4428H34.4489H34.4549H34.461H34.467H34.473H34.479H34.4849H34.4909H34.4968H34.5027H34.5086H34.5144H34.5203H34.5261H34.5319H34.5376H34.5434H34.5491H34.5548H34.5605H34.5662H34.5719H34.5775H34.5831H34.5887H34.5943H34.5999H34.6054H34.611H34.6165H34.622H34.6274H34.6329H34.6384H34.6438H34.6492H34.6546H34.66H34.6653H34.6707H34.676H34.6813H34.6866H34.6919H34.6972H34.7024H34.7077H34.7129H34.7181H34.7233H34.7285H34.7337H34.7388H34.744H34.7491H34.7542H34.7593H34.7644H34.7695H34.7746H34.7796H34.7847H34.7897H34.7947H34.7997H34.8047H34.8097H34.8147H34.8197H34.8246H34.8296H34.8345H34.8394H34.8443H34.8492H34.8541H34.859H34.8639H34.8687H34.8736H34.8784H34.8833H34.8881H34.8929H34.8978H34.9026H34.9074H34.9122H34.9169H34.9217H34.9265H34.9312H34.936H34.9408H34.9455H34.9502H34.955H34.9597H34.9644H34.9691H34.9738H34.9785H34.9832H34.9879H34.9926H34.9973H35.002H35.0066H35.0113H35.016H35.0207H35.0253H35.03H35.0346H35.0393H35.0439H35.0486H35.0532H35.0579H35.0625H35.0671H35.0718H35.0764H35.081H35.0857H35.0903H35.0949H35.0996H35.1042H35.1088H35.1134H35.1181H35.1227H35.1273H35.132H35.1366H35.1412H35.1459H35.1505H35.1551H35.1598H35.1644H35.169H35.1737H35.1783H35.183H35.1876H35.1923H35.1969H35.2016H35.2062H35.2109H35.2156H35.2202H35.2249H35.2296H35.2343H35.239H35.2437H35.2483H35.2531H35.2578H35.2625H35.2672H35.2719H35.2766H35.2814H35.2861H35.2909H35.2956H35.3004H35.3051H35.3099H35.3147H35.3195H35.3243H35.3291H35.3339H35.3387H35.3436H35.3484H35.3532H35.3581H35.363H35.3678H35.3727H35.3776H35.3825H35.3874H35.3923H35.3973H35.4022H35.4072H35.4121H35.4171H35.4221H35.4271H35.4321H35.4371H35.4421H35.4472H35.4522H35.4573H35.4623H35.4674H35.4725H35.4777H35.4828H35.4879H35.4931H35.4982H35.5034H35.5086H35.5138H35.5191H35.5243H35.5295H35.5348H35.5401H35.5454H35.5507H35.556H35.5614H35.5667H35.5721H35.5775H35.5829H35.5883H35.5938H35.5992H35.6047H35.6102H35.6157H35.6212H35.6268H35.6323H35.6379H35.6435H35.6491H35.6548H35.6604H35.6661H35.6718H35.6775H35.6832H35.689H35.6947H35.7005H35.7063H35.7122H35.718H35.7239H35.7298H35.7357H35.7416H35.7476H35.7535H35.7595H35.7656H35.7716H35.7777H35.7837H35.7898H35.796H35.8021H35.8083H35.8145H35.8207H35.827H35.8332H35.8395H35.8458H35.8522H35.8586H35.8649H35.8714H35.8778H35.8843H35.8907H35.8973H35.9038H35.9104H35.917H35.9236H35.9302H35.9369H35.9436H35.9503H35.9571H35.9638H35.9706H35.9775H35.9843H35.9912H35.9981H36.0051H36.012H36.019H36.0261H36.0331H36.0402H36.0473H36.0545H36.0616H36.0689H36.0761H36.0833H36.0906H36.098H36.1053H36.1127H36.1201H36.1276H36.135H36.1426H36.1501H36.1577H36.1653H36.1729H36.1806H36.1883H36.196H36.2038H36.2116H36.2194H36.2273H36.2352H36.2431H36.2511H36.2591H36.2671H36.2752H36.2833H36.2914H36.2996H36.3078H36.316H36.3243H36.3326H36.341H36.3493H36.3578H36.3662H36.3747H36.3832H36.3918H36.4004H36.4091H36.4177H36.4264H36.4352H36.444H36.4528H36.4617H36.4706H36.4795H36.4885H36.4975H36.5066H36.5157H36.5248H36.534H36.5432H36.5525H36.5617H36.5711H36.5805H36.5899H36.5993H36.6088H36.6167V26.25C36.6167 28.2906 35.1337 29.95 33.3333 29.95H5.05V29.9457V29.9349V29.9242V29.9136V29.903V29.8925V29.882V29.8715V29.8611V29.8507V29.8404V29.8301V29.8199V29.8097V29.7996V29.7895V29.7794V29.7694V29.7594V29.7495V29.7396V29.7297V29.7199V29.7102V29.7005V29.6908V29.6812V29.6716V29.662V29.6525V29.643V29.6336V29.6242V29.6148V29.6055V29.5963V29.587V29.5778V29.5687V29.5596V29.5505V29.5414V29.5324V29.5235V29.5146V29.5057V29.4968V29.488V29.4792V29.4705V29.4618V29.4531V29.4445V29.4359V29.4274V29.4189V29.4104V29.4019V29.3935V29.3851V29.3768V29.3685V29.3602V29.352V29.3438V29.3356V29.3275V29.3194V29.3113V29.3032V29.2952V29.2873V29.2793V29.2714V29.2635V29.2557V29.2479V29.2401V29.2324V29.2246V29.217V29.2093V29.2017V29.1941V29.1865V29.179V29.1715V29.164V29.1566V29.1492V29.1418V29.1344V29.1271V29.1198V29.1125V29.1053V29.0981V29.0909V29.0837V29.0766V29.0695V29.0624V29.0553V29.0483V29.0413V29.0343V29.0274V29.0205V29.0136V29.0067V28.9999V28.993V28.9862V28.9795V28.9727V28.966V28.9593V28.9526V28.946V28.9394V28.9328V28.9262V28.9196V28.9131V28.9066V28.9001V28.8936V28.8872V28.8807V28.8743V28.868V28.8616V28.8553V28.8489V28.8427V28.8364V28.8301V28.8239V28.8177V28.8115V28.8053V28.7991V28.793V28.7869V28.7808V28.7747V28.7686V28.7626V28.7565V28.7505V28.7445V28.7386V28.7326V28.7267V28.7207V28.7148V28.7089V28.7031V28.6972V28.6914V28.6855V28.6797V28.6739V28.6681V28.6624V28.6566V28.6509V28.6451V28.6394V28.6337V28.628V28.6224V28.6167V28.6111V28.6054V28.5998V28.5942V28.5886V28.583V28.5775V28.5719V28.5664V28.5608V28.5553V28.5498V28.5443V28.5388V28.5333V28.5279V28.5224V28.5169V28.5115V28.5061V28.5006V28.4952V28.4898V28.4844V28.479V28.4737V28.4683V28.4629V28.4576V28.4522V28.4469V28.4415V28.4362V28.4309V28.4256V28.4203V28.415V28.4097V28.4044V28.3991V28.3938V28.3886V28.3833V28.378V28.3728V28.3675V28.3623V28.357V28.3518V28.3465V28.3413V28.3361V28.3308V28.3256V28.3204V28.3152V28.3099V28.3047V28.2995V28.2943V28.2891V28.2839V28.2787V28.2735V28.2682V28.263V28.2578V28.2526V28.2474V28.2422V28.237V28.2318V28.2266V28.2214V28.2162V28.211V28.2057V28.2005V28.1953V28.1901V28.1849V28.1796V28.1744V28.1692V28.164V28.1587V28.1535V28.1482V28.143V28.1377V28.1325V28.1272V28.122V28.1167V28.1114V28.1061V28.1008V28.0956V28.0903V28.085V28.0796V28.0743V28.069V28.0637V28.0583V28.053V28.0476V28.0423V28.0369V28.0316V28.0262V28.0208V28.0154V28.01V28.0046V27.9991V27.9937V27.9883V27.9828V27.9773V27.9719V27.9664V27.9609V27.9554V27.9499V27.9443V27.9388V27.9333V27.9277V27.9221V27.9165V27.9109V27.9053V27.8997V27.8941V27.8884V27.8828V27.8771V27.8714V27.8657V27.86V27.8543V27.8485V27.8428V27.837V27.8312V27.8254V27.8196V27.8137V27.8079V27.802V27.7961V27.7902V27.7843V27.7784V27.7725V27.7665V27.7605V27.7545V27.7485V27.7425V27.7364V27.7303V27.7243V27.7181V27.712V27.7059V27.6997V27.6935V27.6873V27.6811V27.6749V27.6686V27.6623V27.656V27.6497V27.6434V27.637V27.6306V27.6242V27.6178V27.6113V27.6048V27.5983V27.5918V27.5853V27.5787V27.5721V27.5655V27.5589V27.5522V27.5456V27.5389V27.5321V27.5254V27.5186V27.5118V27.505V27.4981V27.4912V27.4843V27.4774V27.4705V27.4635V27.4565V27.4494V27.4424V27.4353V27.4282V27.421V27.4139V27.4067V27.3995V27.3922V27.3849V27.3776V27.3703V27.3629V27.3555V27.3481V27.3407V27.3332V27.3257V27.3181V27.3105V27.3029V27.2953V27.2876V27.28V27.2722V27.2645V27.2567V27.2489V27.241V27.2331V27.2252V27.2173V27.2093V27.2013V27.1932V27.1852V27.177V27.1689V27.1607V27.1525V27.1443V27.136V27.1277V27.1193V27.1109V27.1025V27.094V27.0855V27.077V27.0685V27.0599V27.0512V27.0425V27.0338V27.0251V27.0163V27.0075V26.9986V26.9897V26.9808V26.9718V26.9628V26.9538V26.9447V26.9356V26.9264V26.9172V26.9079V26.8987V26.8893V26.88V26.8706V26.8611V26.8517V26.8421V26.8326V26.823V26.8133V26.8036V26.7939V26.7841V26.7743V26.7644V26.7546V26.7446V26.7346V26.7246V26.7145V26.7044V26.6943V26.6841V26.6738V26.6635V26.6532V26.6428V26.6324V26.6219V26.6114V26.6008V26.5902V26.5796V26.5689V26.5582V26.5474V26.5365V26.5257V26.5147V26.5037V26.4927V26.4817V26.4705V26.4594V26.4482V26.4369V26.4256V26.4142V26.4028V26.3914V26.3799V26.3683V26.3567V26.345V26.3333V26.3216V26.3098V26.3H33.3333H33.3833V26.25ZM29.95 3.75V18.75C29.95 20.7906 28.467 22.45 26.6667 22.45H3.33333C1.53299 22.45 0.05 20.7906 0.05 18.75V3.75C0.05 1.70942 1.53299 0.05 3.33333 0.05H26.6667C28.467 0.05 29.95 1.70942 29.95 3.75ZM10.05 11.25C10.05 8.15942 12.2663 5.675 15 5.675C17.7337 5.675 19.95 8.15942 19.95 11.25C19.95 14.3406 17.7337 16.825 15 16.825C12.2663 16.825 10.05 14.3406 10.05 11.25Z" fill="#121212" stroke="white" stroke-width="0.1"/>
                </svg>
                ${span} ${body} spent </td></tr>`;
              });
              innerHtml += '</tbody>';
              const tableRoot = tooltipEl.querySelector('table');
              tableRoot.innerHTML = innerHtml;
            }
            /* eslint no-underscore-dangle: 0 */
            const position = this._chart.canvas.getBoundingClientRect();

            tooltipEl.style.opacity = 1;
            tooltipEl.style.padding = '16px';
            tooltipEl.style.paddingRight = '25px';
            tooltipEl.style.backgroundColor = '#fff';
            tooltipEl.style.borderRadius = '9px';
            tooltipEl.style.fontSize = '14px';
            tooltipEl.style.boxShadow = '0px 1px 4px rgba(0, 0, 0, 0.15)';
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.left = `${position.left + window.pageXOffset + tooltip.caretX}px`;
            tooltipEl.style.top = `${position.top + window.pageYOffset + tooltip.caretY}px`;
            tooltipEl.style.fontFamily = `${tooltip._bodyFontFamily}`;
            tooltipEl.style.pointerEvents = 'none';
          },
          callbacks: {
            label(tooltipItem) {
              // eslint-disable-next-line prefer-template
              const label = Math.round(tooltipItem.yLabel * 100) / 100;
              return label;
            },
            labelColor() {
              return {
                borderColor: 'rgb(0, 0, 0)',
                backgroundColor: 'rgb(0, 0, 0)',
              };
            },
            labelTextColor() {
              return '#121212';
            },
          },
        },
        legend: {
          display: false,
        },
      };
    },
  },
  borderWidth: {
    type: Number,
    default: 2,
  },
  elementRef: {
    type: String,
    default: 'myChart',
  },
  labels: {
    type: Array,
    default: null,
  },
};

export default {
};
